import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APMmDevReqTemplateSlot } from '../../../../global/builders/ap_multi_template_dev_req_slot_builder';
import { APMmTemplateSlot } from '../../../../global/builders/ap_multi_template_slot_builder';
import { IAPMmTemplateSlotDatasource } from '../../../../global/datasources/ap_multi_template_slot_dataSource';
import { IAPMmDevReqTemplateSlotDatasource } from '../../../../global/datasources/ap_multi_templatedev_req_slot_dataSource';

export class APMultiDegreeTemplateQuery implements IQuery {
  private __result: {
    isDegreeMapEmpty: boolean;
    hasNonDevReqCourses: boolean;
    hasDevReqCourses: boolean;
    nonDevReqCourses: APMmTemplateSlot[];
    devReqCourses: APMmDevReqTemplateSlot[];
  };

  constructor(
    QueryMediator: IQueryMediator,
    private ngAPMultiTemplateSlotDatasource: IAPMmTemplateSlotDatasource,
    private ngAPMultiDevReqTemplateSlotDatasource: IAPMmDevReqTemplateSlotDatasource
  ) {
    QueryMediator.registerQuery(this, ngAPMultiTemplateSlotDatasource, ngAPMultiDevReqTemplateSlotDatasource);
  }
  run(): this {
    const nonDevReqCourses = this.ngAPMultiTemplateSlotDatasource.values();
    const devReqCourses = this.ngAPMultiDevReqTemplateSlotDatasource.values();
    const hasNonDevReqCourses = nonDevReqCourses.length > 0;
    const hasDevReqCourses = devReqCourses.length > 0;
    const isDegreeMapEmpty = !hasNonDevReqCourses && !hasDevReqCourses;
    this.__result = {
      isDegreeMapEmpty,
      hasNonDevReqCourses,
      hasDevReqCourses,
      nonDevReqCourses,
      devReqCourses
    };
    return this;
  }
  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPMultiDegreeTemplateQuery', APMultiDegreeTemplateQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/queries/ap_multi_degree_template_query.ts